'use client'

import Link from 'next/link'
import Image from 'next/image'
import { useState, useEffect } from 'react'

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  const closeMenu = () => {
    setIsMenuOpen(false)
  }

  const navItems = [
    { href: '/blogs', label: 'Blogs' },
    // { href: '/gallery', label: 'Galerie' },
    { href: '/about', label: 'Impressum' },
    { href: '/contact', label: 'Kontakt' }
  ]

  return (
    <header className={`header-container sticky top-0 z-40 ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container mx-auto px-4 py-4 flex items-center justify-between">
        <Link href="/" className="logo-wrapper" onClick={closeMenu}>
          <Image
            src="/images/logo.jpeg"
            alt="Autoverwertung Logo"
            width={32}
            height={32}
            priority
            className="h-8 w-auto"
          />
          <span className="text-2xl font-bold text-white">Autoverwertung</span>
        </Link>

        <button
          className={`hamburger ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`nav-menu flex gap-4 ${isMenuOpen ? 'mobile-open' : isMenuOpen === false ? 'mobile-hidden' : ''}`}>
          {navItems.map(item => (
            <Link
              key={item.href}
              href={item.href}
              className="nav-link text-white no-underline"
              onClick={closeMenu}
            >
              {item.label}
            </Link>
          ))}
        </nav>
      </div>
    </header>
  )
}

